import React from 'react';

import { Heading, Text, VStack } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

import Image from '../../../shared/components/image/image';
import { Images, Metrics } from '../../../shared/themes';
import imagesUrl from '../../../shared/themes/imagesUrl';

function Step2() {
  const { t } = useTranslation();

  return (
    <VStack space={'md'} mt={'$16'}>
      <Image source={{ uri: imagesUrl.podium }} alt={'Step2'} height={Metrics.images.xxlarge} w={'100%'} resizeMode="contain" />
      <Heading>{t('addCar.makeItStandOut')}</Heading>
      <Text>{t('addCar.makeItStandOutDescription')}</Text>
    </VStack>
  );
}

export default Step2;
